import Flex, { AlignItems, FlexDirection, FlexWrap } from "@galaxy-io/dls/layout/Flex";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";
import type { ComponentProps } from "react";
export function Stack(props: ComponentProps<typeof Flex>) {
  return <Flex direction={FlexDirection.COLUMN} gap={16} minWidth={0} fillWidth {...props} />;
}
export function Inline(props: ComponentProps<typeof Flex>) {
  return (
    <Flex alignItems={AlignItems.CENTER} gap={8} wrap={FlexWrap.WRAP} minWidth={0} {...props} />
  );
}

export const SearchForm = styled.form`
  display: flex;
  align-items: center;
  gap: ${t.space[8]};
  flex: 1;
  min-width: 0;
  > input {
    flex: 1 1 0;
    min-width: 0;
  }
  > button {
    flex-shrink: 0;
  }
`;
export const CompactSelect = styled.div<{ $width?: number }>`
  width: ${({ $width }) => $width || 156}px;
  min-width: 0;
  max-width: 100%;
  flex: 0 0 auto;
`;

export function Inset(props: ComponentProps<typeof Flex>) {
  return <Flex direction={FlexDirection.COLUMN} padding={16} minWidth={0} gap={16} {...props} />;
}
export function FeedViewport(props: ComponentProps<typeof Flex>) {
  return (
    <Flex
      direction={FlexDirection.COLUMN}
      grow={1}
      shrink={1}
      minHeight={0}
      minWidth={0}
      overflow="hidden"
      {...props}
    />
  );
}
